<template>
    <div class="instructor-manage">
        <SuperAdminHeader>
            <template v-if="userProfile.user" v-slot:userName>
                {{ userProfile.user.firstName }} {{ userProfile.user.lastName }}
            </template>
            <template v-slot:roleName>{{ $t('student') }}</template>
        </SuperAdminHeader>
        <div class="instructor-manage__container">
            <Sidebar :role="'student'" :noteSize="noteSize"/>
            <div class="instructor-manage__body">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationService from '@/_services/notification.service'
import SuperAdminHeader from '@/components/navigations/sidebars/SuperAdminHeader.vue'
import Sidebar from '@/components/navigations/sidebars/Sidebar.vue'

export default {
  name: 'StudentManage',
  components: { Sidebar, SuperAdminHeader },
  data () {
    return {
      noteSize: 0
    }
  },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    }
  },
  created () {
    this.getParentNotifications()
  },
  methods: {
    getParentNotifications () {
      NotificationService.getUserNotifications(this.userProfile.user.id, 'UNREAD').then(result => {
        if (result._embedded) {
          this.noteSize = result._embedded.notificationResourceList.length
          NotificationService.notificationSize = result._embedded.notificationResourceList.length
        } else {
          NotificationService.notificationSize = 0
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.instructor-manage {
    background: #f8f8fb;

    &__container {
        display: flex;
        /*height: calc(100vh - 76px);*/
    }

    &__body {
        width: calc(100% - 100px);
        margin-left: 100px;
        min-height: 88vh;
        overflow-x: auto;
        /*width: calc(100% - 96px);*/
        /*overflow-y: auto;*/
    }
    .super-admin-sidebar {
        /**/
        position: fixed;
        top: 0;
        height: 100vh;
    }
}
</style>
